/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarButtons_displayInfo = {|
  +ctas: ?{|
    +showPurchase: ?boolean;
    +showMakeOffer: ?boolean;
    +showRequestPrice: ?boolean;
    +showRequestSourcing: ?boolean;
    +showFollowCategory: ?boolean;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_displayInfo",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "showPurchase",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "showMakeOffer",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "showRequestPrice",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "showRequestSourcing",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "showFollowCategory",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo"
};

module.exports = fragment;
